module.exports = __webpack_public_path__ + "static/media/complete.ae5dfff0.svg";